import { render, staticRenderFns } from "./ProductVariationPrice.vue?vue&type=template&id=67c4092e&scoped=true&"
import script from "./ProductVariationPrice.vue?vue&type=script&lang=js&"
export * from "./ProductVariationPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4092e",
  null
  
)

export default component.exports